var StoreBrandingType = /* @__PURE__ */ ((StoreBrandingType2) => {
  StoreBrandingType2["CustomDTCStore"] = "CustomDTCStore";
  StoreBrandingType2["CustomStore"] = "CustomStore";
  StoreBrandingType2["BrandStore"] = "BrandStore";
  StoreBrandingType2["UniversalStore"] = "UniversalStore";
  return StoreBrandingType2;
})(StoreBrandingType || {});
var SiteBrandingType = /* @__PURE__ */ ((SiteBrandingType2) => {
  SiteBrandingType2["CustomDTCStore"] = "CustomDTCStore";
  SiteBrandingType2["CustomStore"] = "CustomStore";
  SiteBrandingType2["BrandStore"] = "BrandStore";
  SiteBrandingType2["UniversalStore"] = "UniversalStore";
  return SiteBrandingType2;
})(SiteBrandingType || {});
export {
  SiteBrandingType,
  StoreBrandingType
};
//# sourceMappingURL=type.js.map
